// extracted by mini-css-extract-plugin
var _1 = "wk0Tx";
var _2 = "Da9z6";
var _3 = "w1j2s";
var _4 = "OoEUA";
export { _1 as "base", _2 as "control", _3 as "disabled", _4 as "selected" }
